export const themes = {
  chauffeur: {
    primary: '#C0C0C0',    //charcoal grey // Rich black
    secondary: '#2C2C2C',     // Taxi yellow
    accent: '#333333',  // Dark grey
    highlight: '#0055A5',  // Professional blue
    light: '#f5f5f5',     // Off white
    text: '#ffffff',       // White text
    border: '#4a4a4a'      // Grey border
  }
};
